import React from 'react';

const ImportsContext = React.createContext({});

export default ImportsContext;
